const env = process.env.NODE_ENV || 'development'

export default {
  userId: null,
  install (Vue, options) {
    Vue.prototype.loggly = this
    if (env === 'production' && !document.getElementById('loggly')) {
      const script = document.createElement('script')
      script.setAttribute('id', 'loggly')
      script.setAttribute('src', './static/loggly.tracker-latest.min.js')
      script.setAttribute('async', '')
      script.onload = () => {
        window._LTracker = _LTracker || [] // eslint-disable-line
        // eslint-disable-next-line
        _LTracker.push({
          'logglyKey': process.env.LOGGLY_KEY,
          'sendConsoleErrors': true,
          'tag': 'customer-licensing-portal'
        })
      }
      document.head.appendChild(script)
    }
  },
  setUserId (userId) {
    this.userId = userId
  },
  log (message) {
    if (env === 'production') {
      _LTracker.push(JSON.stringify({ userId: this.userId, message })) // eslint-disable-line
    } else {
      console.log(message)
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/Loggly.js